import { OptionsEnum, ResolverEnum } from 'features/RefundTicketsSummary/types';

export const REFUND_OPTIONS = [OptionsEnum.FULL, OptionsEnum.PARTIAL];

export const RESOLVERS = [ResolverEnum.percentage, ResolverEnum.dollars];
